import { BuildingOffice2Icon } from "@heroicons/react/24/outline";
import logo from "../../assets/logo.svg";

const SpinningLoader = () => {
  return (
    <div className="text-center">
        <div className="flex justify-center mb-2">
          <div className="w-16 h-16 rounded-xl flex items-center justify-center mr-5">
            {/* <BuildingOffice2Icon className="w-8 h-8 text-white" /> */}
            <img 
              src={logo} 
              alt="BuildCheap Logo" 
              className="w-32 h-32 object-contain"
            />
          </div>
        </div>
        <div className="mb-4">
          <svg
            className="animate-spin h-8 w-8 text-slate-700 mx-auto"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </div>
        <p className="text-slate-600 font-medium">Carregando...</p>
      </div>
  );
};

export default SpinningLoader;